// Get Customer financial report data
export const GET_CUSTOMER_REVENUE = `
    query GetCustomerFinancialReportData($input:CustomerReportInput!,$skip:Float,$take:Float){
        getCustomerFinancialReportData(input: $input, skip: $skip, take: $take){
            pageInfo{
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
                sap_customer_id
                customer_name
                main_customer_id
                child_customer_id
                data_month_info
                rank_name
                city_name
                proc_haolai
                proc_total_discount
                proc_process_price_sap
                proc_total_dt
                prod_haolai
                prod_total_discount
                prod_process_price_sap
                prod_total_dt
                prod_final_price
                prod_rank_up
                proc_rank_up
            }
        }
    }
`;

export const GET_CUSTOMER_GROUP_REVENUE = `
    query GetCustomerDateReport($input:CustomerReportInput!,$skip:Float,$take:Float){
        getCustomerDataReport(input: $input, skip: $skip, take: $take){
            pageInfo{
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
            sap_customer_id
            customer_name
            child_customer_id
            main_customer_id
            city_name
            process_age
            process_gold_with_of_stook
            process_product_id
            process_species
            quantity_process
            product_id
            product_age
            product_gold_with_of_stook
            product_species
            quantity_product
            rank_name
            }
        }
    }
`;

// Get Sales Comparison Report
export const GET_TEAM_SALE_REVENUE = `query GetSalesComparisonReport($input:SalesComparisonReportInput!,$skip:Float,$take:Float){
    getSalesComparisonReport(input: $input, skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            city_name
            team_sales_id
            trip_id
            route_id
            total_process_price_current
            total_process_price_last_year
            total_process_price_last_month
            plan_revenue
            percent_current
            percent_last_year
            percent_last_month
        }
    }
}`;

// Get Customer Frequency Trading Report
export const GET_CUSTOMER_FREQUENCY_TRADING = `query GetCustomerFrequencyTradingReport($input:CustomerFrequencyTradingReportInput!,$skip:Float,$take:Float){
    getCustomerFrequencyTradingReport(input: $input, skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
           customer_name
           sap_customer_id
           main_customer_id
           child_customer_id
           city_name
           rank_name
           proc_product_quantity_per_order
           prod_product_quantity_per_order
           proc_total_dt
           prod_total_dt
           proc_frequency
           prod_frequency
           proc_latest_order_date
           prod_latest_order_date
        }
    }
}`;

// Get Sales Province Report
export const GET_MARKET_COVERAGE = `query GetSalesProvinceReport($input: CustomerFrequencyTradingReportInput!,$skip:Float,$take:Float){
    getSalesProvinceReport(input: $input, skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
           city_name
           team_sales_id
           total_customers_current_period
           total_customers_same_period_last_year
           total_customers_last_period
           plan_customers_current_period
           plan_customers_same_period_last_year
           plan_customers_last_period
           interaction_customers_current_period
           interaction_customers_same_period_last_year
           interaction_customers_last_period
           successful_transactions_current_period
           successful_transactions_same_period_last_year
           successful_transactions_last_period
           total_revenue_current_period
           total_revenue_same_period_last_year
           total_revenue_last_period
           interaction_rate_current_period
           interaction_rate_same_period_last_year
           interaction_rate_last_period
           success_rate_current_period
           success_rate_same_period_last_year
           success_rate_last_period
        }
    }
}`;

// Get Sales Line Efficiency Report
export const GET_SALES_LINE_EFFICIENCY = `query GetSalesLineEfficiencyReport($input: CustomerFrequencyTradingReportInput!,$skip:Float,$take:Float){
    getSalesLineEfficiencyReport(input: $input, skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
           stt
           implementation_date
           team_sales_id
           route_id
           trip_id
           sales_planning_id
           customer
           sale_started_date
           sale_end_date
           total_time
           discount
           average_revenue
           process_price
           percent_price
           plant_longitude
           plant_latitude
           cust_latitude
           cust_longitude
           average_month_revenue
        }
    }
}`;
